export class Constants {
  static SSO_PROVIDER_DISPLAY_MAP: Record<string, string> = { azureadidp: ' Azure SSO' };
  static ERROR_MSG_SERVICE_UNAVALIABLE = 'Service unavailable, please try again in a few minutes.';

  // Clone Documents Error Messages
  static CLONE_ERROR_MESSAGES = {
    NETWORK_ERROR: 'Network error occurred. Please check your connection and try again.',
    PERMISSION_DENIED: 'You do not have permission to clone documents to this collection.',
    COLLECTION_NOT_FOUND: 'The selected collection was not found. Please refresh and try again.',
    DOCUMENTS_NOT_FOUND: 'Some selected documents could not be found. Please refresh and try again.',
    INVALID_REQUEST: 'Invalid request. Please check your selection and try again.',
    DUPLICATE_DOCUMENTS: 'Some documents are already in the target collection.',
    SERVER_ERROR: 'An unexpected error occurred. Please try again later.',
    TIMEOUT_ERROR: 'Request timed out. Please try again.',
    VALIDATION_ERROR: 'Invalid data provided. Please check your selection.',
    PARTIAL_SUCCESS: 'Some documents were cloned successfully, but others failed.',
    NO_DOCUMENTS_SELECTED: 'Please select documents to clone.',
    COLLECTION_LOAD_ERROR: 'Error loading collections. Please try again.',
    CLONE_OPERATION_FAILED: 'Clone operation failed. Please try again.'
  };
}
